/**
 * Enum representing the possible results duration options for displaying lab results and vital signs.
 */

export enum ResultsDurationType {
    Latest,
    Last2,
    Last3,
    All
}
